<template>
    <div class="alert alert-info" role="alert">
        <div class="row">
            <div class="col-1 d-flex justify-content-center align-items-center">
                <i class="fas fa-info fa-lg text-info col-1 text-center border-info border-circle align-self-center"></i>
            </div>
            <div class="col-11">
                Du hast deine E-Mail-Adresse noch nicht bestätigt!<br>
                Um unser Angebot voll und ganz nutzen zu können, brauchst du jedoch eine gültige E-Mail-Adresse.<br>
                <a :href="verificationEmailResendUrl" target="_blank" class=" text-info">Bestätigungsmail erneut zuschicken</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EmailVerified",
        props: ['verificationEmailResendUrl']
    }
</script>

<style scoped>

</style>